"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var UserIdentityButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UserIdentityButton, _React$Component);

  function UserIdentityButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UserIdentityButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserIdentityButton).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(UserIdentityButton, [{
    key: "onKeyPress",
    value: function onKeyPress(event) {
      // Handles the "Space" and "Enter" keypress events.
      // Because the anchor tag lacks an "href" attribute, this needs to provided.
      var isSpace = event.key === ' ' || event.charCode === 32;
      var isEnter = event.key === 'Enter' || event.charCode === 13;

      if (isSpace || isEnter) {
        this.onOpen();
      }
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      var onOpen = this.props.onOpen;
      onOpen && onOpen();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          identityId = _this$props.identityId,
          identityName = _this$props.identityName;
      var innerContent = !identityId ? _react.default.createElement("span", null, "Select profile") : _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "identity-button__label"
      }, "Acting as: "), identityName);
      return (// Bribing a cop because the shared header component only styles anchor tags.

        /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
        _react.default.createElement("a", {
          role: "button",
          tabIndex: "0",
          onClick: this.onOpen,
          onKeyPress: this.onKeyPress,
          className: "identity-button"
        }, innerContent)
      );
    }
  }]);
  return UserIdentityButton;
}(_react.default.Component);

var _default = UserIdentityButton;
exports.default = _default;